import { render, staticRenderFns } from "./PresupuestosPendientes.vue?vue&type=template&id=171a49a6&scoped=true&"
import script from "./PresupuestosPendientes.vue?vue&type=script&lang=js&"
export * from "./PresupuestosPendientes.vue?vue&type=script&lang=js&"
import style0 from "./PresupuestosPendientes.vue?vue&type=style&index=0&id=171a49a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171a49a6",
  null
  
)

export default component.exports